// extracted by mini-css-extract-plugin
export var buttonWrapper = "gD_nW";
export var paddingSmall = "gD_nX";
export var paperContent = "gD_nT";
export var paperExpandable = "gD_nS";
export var paperTrigger = "gD_nY";
export var paperTriggerSmall = "gD_nZ";
export var paperTriggerWrapper = "gD_nV";